import { render, staticRenderFns } from "./WorkoutCard.vue?vue&type=template&id=33a2446e&scoped=true"
import script from "./WorkoutCard.vue?vue&type=script&lang=js"
export * from "./WorkoutCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33a2446e",
  null
  
)

export default component.exports